export default "__VITE_ASSET__54417311__"